const locale = {
	PAGE_VERSION_UPDATE_TITLE: 'New update',
	PAGE_VERSION_UPDATE_DESCRIPTION:
		'Refreshing the cache is required on desktop devices via {windowsRefresh} (or {macOsRefresh} on macOS) or on mobile devices following the guidance of {windowsLink} (or {appleLink})',
	PAGE_VERSION_UPDATE_VERSION_CURRENT: 'Client version: {date}',
	PAGE_VERSION_UPDATE_VERSION_LATEST: 'Latest version: {date}'
};

export default locale;
